import { UPDATE_PREFERRED_PLATFORM } from 'root/src/client/logic/userData/actionIds'

export default payload => ({
	type: UPDATE_PREFERRED_PLATFORM,
	payload,
})
